// Character Lore Data — Dominion Mod
// Structured lore transcribed from markdown source files in mods/dominion/lore/

export const CHARACTER_LORE = {
  'albert-victor': {
    nameZh: '阿尔伯特·维克托',
    titleZh: '议会金融家',
    identity: '维度议会 · 经济委员会前主席',
    alignment: '秩序 / 稳定 / 资本理性',
    background: `在成为维度代理人之前，**阿尔伯特·维克托**从未踏足过任何战场。

他的一生，几乎全部发生在会议室、交易大厅与预算表之间。

在原生世界中，阿尔伯特曾是跨国金融联盟的首席谈判代表。他并不以投机闻名，也不擅长制造奇迹——恰恰相反，他以**避免灾难**著称。

当市场过热时，是他提出降温方案；当资本恐慌蔓延时，是他通过约束性条款阻止了系统性崩溃。同僚评价他"保守""缺乏想象力"，但在他任期内，没有一座核心城市因为财政失序而崩塌。

维度议会正是在这一点上注意到了他。`,
    joining: `在多元世界体系中，**最大的威胁并非战争，而是失控的扩张**。
世界并不是被摧毁的，而是被"过度开发""错误激励"和"短视决策"慢慢掏空。

阿尔伯特被召入议会时，面对的是一份冷静而克制的评估报告：

> "该候选人缺乏冒险精神，但其稳定性指数处于 99.7% 分位。"

他没有犹豫。

在议会中，阿尔伯特迅速成为**城市世界**与**金融型文明**的主要维护者。他推动建立统一的地产评估模型、跨世界结算标准，以及后来被广泛采用的**风险缓释协议**。

这些制度并不耀眼，但它们决定了世界是否还能继续运作。`,
    styleIntro: '阿尔伯特从不追求极限收益。\n\n他始终坚持三条信念：',
    style: [
      '资本的真正力量，在于流动而非积累',
      '一块被合理定价的地产，比十块泡沫资产更可靠',
      '真正的胜利，是让对手意识不到你已经赢了',
    ],
    styleOutro: `在棋盘上，他极少做出"看起来很强"的操作。
但当回合数拉长、资金链复杂化，其他代理人往往才发现——

**关键节点，早已被他悄然控制。**`,
    relationships: [
      { target: '概率投机者', description: '表面尊重，内心警惕；认为其行为增加系统性风险' },
      { target: '政治操盘手', description: '频繁合作，但从不完全共享信息' },
      { target: '拓荒型代理人', description: '视为必要风险，始终主张设立严格边界' },
    ],
    themeSummary: '他不是来赢一局游戏的，\n他是来确保这套规则还能继续运转。',
  },

  'lia-startrace': {
    nameZh: '莉亚·星痕',
    titleZh: '星际拓荒者',
    identity: '维度议会 · 外环世界开发署首席代理人',
    alignment: '探索 / 技术 / 高风险增长',
    background: `与大多数维度代理人不同，**莉亚·星痕**并非来自一个稳定、成熟的世界。

她的原生文明诞生于一片资源稀薄、轨道极不稳定的星系。恒星频繁耀斑、行星周期紊乱，任何依赖长期规划的社会结构都会迅速瓦解。在那里，**"安全"并不是一个被认真讨论的概念**。

莉亚第一次驾驶勘探舰时还未成年。
她学会的不是如何避免失败，而是如何在失败发生前多前进一步。`,
    noticed: `维度议会最初并不看好她的世界。

评估报告中的结论近乎冷酷：

> "该文明存续概率低于 18%，不具备长期治理价值。"

但莉亚提交了一份补充报告。
报告中没有情绪，也没有恳求，只有一行反问：

> *"如果所有高风险世界都被放弃，那么多元宇宙的边界，是否将永远停止扩展？"*

这份报告没有改变评估结论，却改变了**评估标准本身**。`,
    joining: `莉亚被破格吸纳，并非因为她证明了成功，而是因为她**重新定义了失败的意义**。

在议会体系中，她负责的并不是核心城市或成熟文明，而是被标注为"外环"的世界：
资源未知、规则不稳定、灾害频发。

她推动引入了后来被称为**"阶段性开发协议"**的制度——
允许世界在高风险阶段获得技术与资金倾斜，但同时接受更高的失败概率。

在她看来，
**没有任何文明是在"安全模式"下诞生的。**`,
    styleIntro: '莉亚并不掩饰自己的激进。\n\n她相信三件事：',
    style: [
      '**风险不是错误，而是信息**',
      '**科技存在的意义，是缩短试错周期**',
      '**真正的停滞，比灾难更致命**',
    ],
    styleOutro: `在棋盘上，她往往是第一个进入未知区域的代理人。
她的扩张速度令人不安，失败记录同样触目惊心。

但当其他代理人开始意识到新规则、新资源、新路径的存在时，
莉亚通常已经完成了下一轮部署。`,
    relationships: [
      { target: '议会金融家', description: '尊重其稳定性，但认为其策略过于依赖既有结构' },
      { target: '秩序执行官', description: '频繁发生理念冲突，对方认为她"放任风险"' },
      { target: '长期主义代理人', description: '在后期阶段常形成互补合作关系' },
    ],
    themeSummary: '不是所有世界都能被拯救，\n但如果没人愿意先踏出去一步，\n那么多元宇宙本身就失去了继续存在的意义。',
  },

  'marcus-grayline': {
    nameZh: '马库斯·灰线',
    titleZh: '政治操盘手',
    identity: '维度议会 · 协调与仲裁委员会常任代表',
    alignment: '政治 / 联盟 / 权力平衡',
    background: `在维度议会内部，**马库斯·灰线**从来不是最引人注目的那一个。

他没有拯救过濒临毁灭的世界，也未曾主导过任何传奇式的扩张计划。
如果必须用一个词来形容他的履历，那更接近于——**"始终在场"**。

在他的原生世界里，马库斯成长于一个高度分裂的多城邦体系。
战争并不频繁，但冲突从未真正停止：贸易壁垒、意识形态对立、联盟的反复瓦解，让任何单点胜利都显得短暂而脆弱。

马库斯很早就意识到一个事实：

> **世界往往不是被打败的，而是被无法协调的利益拖垮的。**`,
    noticed: `在一次跨城邦谈判中，马库斯并未提出任何新的条款。
他只是重新排列了谈判顺序，并改变了投票权重的计算方式。

结果是：
没有任何一方"完全满意"，但也没有任何一方选择退出。

维度议会在事后评估中记录道：

> "该候选人不制造共识，但能有效防止共识破裂。"

这正是议会长期缺乏、却难以量化的能力。`,
    joining: `马库斯进入议会后，被分配到**协调与仲裁委员会**——
这是一个几乎不产生荣誉，却承担大量失败责任的部门。

他的工作并不是制定宏伟蓝图，而是处理那些被其他代理人忽视的问题：
联盟内部的利益分配、投票机制的漏洞、临时协议的执行边界。

他推动建立了后被称为**"灰线仲裁模型"**的制度：
允许联盟在不解体的前提下，进行阶段性重组与权力再分配。

在这个模型中，没有永久的盟友，也没有永恒的敌人，
只有**尚未结算的关系**。`,
    styleIntro: '马库斯很少主动扩张。\n\n他更倾向于出现在关键节点之前，确保没有任何一方获得不可逆的优势。\n\n他始终遵循三条原则：',
    style: [
      '**权力失衡比资源短缺更危险**',
      '**联盟的价值，在于它随时可以被重新谈判**',
      '**真正的控制，是让所有人都觉得规则仍然公平**',
    ],
    styleOutro: `在棋盘上，他的存在往往让局势变得"复杂"。
回合进展变慢、决策成本上升，但崩盘的概率显著降低。`,
    relationships: [
      { target: '议会金融家', description: '高度互信，但在长期目标上存在分歧' },
      { target: '星际拓荒者', description: '认为其必要却危险，倾向设置政治缓冲' },
      { target: '暗影议员', description: '保持警惕，认为其擅长利用制度盲区' },
    ],
    themeSummary: '秩序并不意味着停滞，\n而是意味着在崩溃发生之前，\n总有人愿意重新画线。',
  },

  'evelyn-zero': {
    nameZh: '伊芙琳·零号',
    titleZh: '概率投机者',
    identity: '维度议会 · 非线性事件观测员',
    alignment: '不确定性 / 机会主义 / 高波动',
    background: `在维度议会的档案系统中，**伊芙琳·零号**的编号并非象征资历，而是一个警告。

"零号"，意味着**无法被稳定归类的变量**。

她的原生世界是一处长期处于概率异常状态的维度裂隙。
因果关系并不总是线性成立：决策与结果之间，经常出现延迟、反转，甚至完全错位的情况。

在那样的环境中，计划是一种奢侈品。
而伊芙琳学会的，是如何在混乱中**识别偏差本身**。`,
    noticed: `议会第一次注意到伊芙琳，并非因为她成功了什么项目，而是因为她**成功地失败了**。

在一次高风险世界介入行动中，她的决策导致了资源配置的全面崩溃。
按照常规评估，这应当是一次明确的负面案例。

但随后的观测数据显示：
该世界的长期稳定性指数，反而在崩溃之后显著上升。

评估报告中罕见地标注了一条附注：

> "该代理人似乎能够在失败路径中，提前触发系统的自我修正机制。"`,
    joining: `伊芙琳被以"观察员"而非"执行官"的身份纳入议会体系。
她并不直接主导世界开发，而是被允许在特定条件下**介入事件流本身**。

她推动设立了后来被称为**"概率再采样机制"**的实验性规则：
在关键事件节点，引入有限度的结果重选权。

该机制曾多次引发激烈争论——
因为它并不提高成功率，只是**重新分配失败发生的方式**。`,
    styleIntro: '伊芙琳从不相信"最优解"。\n\n她只关心三件事：',
    style: [
      '**结果是否被过早锁定**',
      '**系统是否还有回旋空间**',
      '**失败是否仍然具备信息价值**',
    ],
    styleOutro: `在棋盘上，她的行动往往显得随意，甚至不合逻辑。
她会放弃看似稳妥的收益，去追逐概率极低的分支。

但当局势陷入僵局，或胜负被提前决定时，
她常常是唯一仍然能够**改变结果分布**的代理人。`,
    relationships: [
      { target: '议会金融家', description: '认为其行为破坏稳定性，对其保持制度性限制' },
      { target: '政治操盘手', description: '对其能力保持谨慎观察，偶尔用于打破僵局' },
      { target: '星际拓荒者', description: '在高风险环境中存在短暂的战术协同' },
    ],
    themeSummary: '问题从来不是失败，\n而是你是否足够早地意识到，\n成功这条路径本身就是偏置的。',
  },

  'knox-ironlaw': {
    nameZh: '诺克斯·铁律',
    titleZh: '秩序执行官',
    identity: '维度议会 · 法规与执行委员会监察长',
    alignment: '秩序 / 约束 / 强制执行',
    background: `在维度议会内部，**诺克斯·铁律**的名字，往往意味着一件事——
**讨论已经结束。**

他并非因卓越的谈判能力而闻名，恰恰相反，他几乎从不参与协商。
在他的原生世界里，规则不是共识的产物，而是文明得以存续的**最低条件**。

那是一个曾经高度自由的世界。
市场几乎没有限制，城市扩张毫无边界，个人与组织都被鼓励"突破规则"。

最终，规则并没有被突破，而是被彻底耗尽。`,
    noticed: `在原生世界濒临系统性崩溃前夕，诺克斯被临时授予了全面执行权。
没有议会投票，没有公众辩论，只有一条明确指令：

> "阻止失控，代价不计。"

他随即冻结了全部跨城交易，强制拆分垄断实体，并暂停了所有高风险扩张项目。
短期内，世界经济几乎停摆，社会反弹剧烈。

但在六个周期之后，基础结构重新稳定，
而此前被认为"不可触碰"的权力中心，再未恢复原状。

这次行动被记录为：

> **"一次政治上不可接受，但系统上必要的干预。"**`,
    joining: `诺克斯加入维度议会，并非因为他的做法被广泛认同，
而是因为议会意识到——**有些边界，必须由不受欢迎的人来守住**。

他被任命为法规与执行委员会的监察长，
拥有在特定条件下**绕过常规程序**的权限。

诺克斯本人从未为此辩护。
在他看来，规则的合法性来自于其是否能被执行，而非是否令人满意。`,
    styleIntro: '诺克斯极度厌恶模糊地带。\n\n他始终坚持三条原则：',
    style: [
      '**无法执行的规则，本质上不存在**',
      '**例外一旦出现，就会被不断复制**',
      '**秩序不是善意，而是约束的结果**',
    ],
    styleOutro: `在棋盘上，他的存在显著提高了行动成本。
扩张速度被压制，投机行为遭到惩罚，短期收益明显下降。

但与此同时，
**系统性崩盘的概率几乎被彻底消除。**`,
    relationships: [
      { target: '政治操盘手', description: '认为其手段过于僵硬，但承认其稳定价值' },
      { target: '概率投机者', description: '长期处于制度性对立关系' },
      { target: '议会金融家', description: '在危机时期高度协同，平时保持距离' },
    ],
    themeSummary: '规则之所以存在，\n不是为了被理解，\n而是为了在必要时，\n被毫不犹豫地执行。',
  },

  'sophia-ember': {
    nameZh: '索菲亚·余烬',
    titleZh: '危机套利者',
    identity: '维度议会 · 灾后重建与风险回收特别顾问',
    alignment: '危机管理 / 逆周期 / 重建驱动',
    background: `在维度议会中，**索菲亚·余烬**通常只在两种情况下被提及：
**灾难已经发生，或者即将发生。**

她的原生世界并非毁于一次突如其来的崩塌，而是经历了漫长而反复的衰退周期。
经济、生态与社会结构不断遭遇局部失败，却又一次次被勉强修复。

在那里，索菲亚学到的第一课不是如何避免危机，
而是如何在危机之后，**判断哪些部分值得被拯救，哪些必须被放弃**。`,
    noticed: `在一次被记录为"失败"的多世界援助计划中，索菲亚做出了一个极具争议的决定。

当其他代理人试图平均分配资源、维持表面稳定时，
她却主动切断了对多个低效区域的支持，将有限资源集中投入到少数核心节点。

短期内，这一决策导致了多个区域的彻底崩溃。
但在随后的长期观测中，存续下来的区域展现出了**异常强劲的自我修复能力**。

评估报告在结论中写道：

> "该代理人并未阻止灾难，
> 但她显著提高了灾难之后，系统重新组织的效率。"`,
    joining: `索菲亚并不是以"执行官"或"管理者"的身份加入议会的。
她的职位描述中，始终包含一个特殊前提：

> **"仅在危机阶段生效。"**

她推动建立了被称为**"余烬回收协议"**的机制：
允许在世界遭受重大打击后，重新评估资产、地产与规则的存续价值。

在该机制下，失败不再只是损失，
而是成为下一轮增长的**原始燃料**。`,
    styleIntro: '索菲亚从不否认灾难的破坏性。\n\n但她坚持三条判断标准：',
    style: [
      '**并非所有损失都值得挽回**',
      '**重建的速度，比修复的完整性更重要**',
      '**真正的风险，是在错误的结构上继续投入资源**',
    ],
    styleOutro: `在棋盘上，她往往在局势最糟糕时开始显现优势。
他人的资产被冻结、收益中断，而她却能迅速完成结构重组。

当世界逐渐恢复秩序时，
索菲亚通常已经完成了下一轮布局。`,
    relationships: [
      { target: '秩序执行官', description: '在危机阶段高度协作，平稳时期理念分歧明显' },
      { target: '议会金融家', description: '在资产评估与回收阶段保持专业互信' },
      { target: '理想主义议员', description: '常因"是否值得拯救所有人"产生冲突' },
    ],
    themeSummary: '灰烬并不意味着终结，\n它只是告诉你，\n哪些东西已经不值得继续燃烧。',
  },

  'cassian-echo': {
    nameZh: '卡西安·回声',
    titleZh: '信息商人',
    identity: '维度议会 · 情报与非对称事务协调官',
    alignment: '信息优势 / 间接控制 / 不对称博弈',
    background: `在维度议会的正式记录中，**卡西安·回声**出现得并不频繁。
但在所有关键决策的旁注、备忘与修订版本里，他的名字几乎无处不在。

他的原生世界并非因战争或灾难而改变轨迹，
而是被**信息分配的不均衡**逐步重塑。
真相从未消失，只是被切割、延迟、定价，再出售。

在那样的环境中，卡西安学会的不是如何制造信息，
而是如何判断——**谁在什么时候，应该知道多少。**`,
    noticed: `在一次多世界联合行动中，议会遭遇了前所未有的失败。
并非因为判断错误，而是因为**判断过早被对手知晓**。

复盘过程中，卡西安提交了一份异常简短的报告：
没有分析，没有指控，只有一张信息流向图。

图中清晰标注了：
哪些节点接收了超出其职责范围的内容，
以及这些"提前知情"如何一步步放大为系统性反制。

评估记录写道：

> "该候选人未提供解决方案，
> 但他重新定义了问题本身。"`,
    joining: `卡西安被引入议会，并非作为传统意义上的情报官。
他的授权范围并不包括命令、冻结或直接干预。

他所推动建立的，是后来被称为**"回声延迟协议"**的制度：
允许在特定条件下，对信息的传播进行时间与完整度的再分配。

在该协议下，
信息不再被简单地视为资源，
而被视为一种**具有衰减曲线的变量**。`,
    styleIntro: '卡西安从不争夺正面优势。\n\n他关注三件事：',
    style: [
      '**谁先知道**',
      '**谁知道得更多**',
      '**谁以为自己已经知道全部**',
    ],
    styleOutro: `在棋盘上，他的行动往往并不改变即时收益。
但他会不断调整对手的判断基础，使其在关键节点做出次优决策。

当结果揭晓时，
多数代理人甚至无法确定自己究竟输在了哪一步。`,
    relationships: [
      { target: '政治操盘手', description: '高度互补，常在联盟谈判中形成隐性配合' },
      { target: '概率投机者', description: '在事件预测上存在有限合作，但彼此防范' },
      { target: '秩序执行官', description: '长期处于制度张力之中，对信息控制边界分歧明显' },
    ],
    themeSummary: '控制并不来自力量，\n而来自这样一个事实：\n当你意识到真相时，\n已经来不及重新选择。',
  },

  'mira-dawnlight': {
    nameZh: '米拉·晨曦',
    titleZh: '理想主义议员',
    identity: '维度议会 · 长期发展与伦理评估委员会代表',
    alignment: '长期主义 / 共识建设 / 可持续发展',
    background: `在维度议会这样一个由效率、风险与权力构成的体系中，
**米拉·晨曦**的存在常被认为"过于温和"。

她的原生世界并不富裕，也从未在任何维度排名中名列前茅。
那是一个发展缓慢、技术进步谨慎、几乎没有爆发式增长的文明。
但在长时间跨度的观测中，它呈现出一个异常稳定的特征——
**几乎从未发生不可逆的系统性崩溃**。

米拉正是在这样的环境中成长起来的。`,
    noticed: `在一次跨世界发展评估中，米拉负责的是一项最不受欢迎的任务：
评估那些"看起来已经失败，但仍然存在"的世界。

她提交的报告并未包含任何令人振奋的预测，
只是反复强调一个被忽视的指标：
**长期幸存率**。

评估附注中记录道：

> "该候选人持续拒绝以短期效率作为唯一成功标准。"

这本应是一个减分项。
但当多个高收益世界在后续周期中相继崩溃后，
米拉的模型成为少数仍然有效的参考框架。`,
    joining: `米拉进入议会后，被分配到长期发展与伦理评估委员会。
这是一个决策节奏极慢、影响却极其深远的部门。

她推动引入了被称为**"延迟回报评估机制"**的规则：
在重大开发决策中，强制引入跨周期成本与社会稳定性权重。

这一机制多次被指责"拖慢进程"。
米拉从不否认这一点。

在她看来，
**被延迟的成功，远比被提前透支的繁荣更可靠。**`,
    styleIntro: '米拉很少在早期阶段展现优势。\n\n她坚持三条判断原则：',
    style: [
      '**并非所有增长都值得加速**',
      '**系统能否被理解，比是否高效更重要**',
      '**真正的进步，应当对下一代仍然成立**',
    ],
    styleOutro: `在棋盘上，她的布局往往显得保守而缓慢。
但随着回合数增加，她的资源结构愈发稳固，
风险敞口持续下降。

当其他代理人开始为早期决策付出代价时，
米拉通常仍然保有足够的调整空间。`,
    relationships: [
      { target: '危机套利者', description: '在灾后阶段形成互补合作' },
      { target: '星际拓荒者', description: '在扩张速度与风险容忍度上存在长期分歧' },
      { target: '秩序执行官', description: '在规则必要性上高度一致，但手段取向不同' },
    ],
    themeSummary: '真正重要的不是这一回合发生了什么，\n而是当游戏结束时，\n世界是否依然值得继续存在。',
  },

  'renn-chainbreaker': {
    nameZh: '雷恩·断链',
    titleZh: '破局者',
    identity: '维度议会 · 反垄断与结构重组特派代理',
    alignment: '反集中化 / 结构破坏 / 竞争重启',
    background: `在维度议会的历史中，**雷恩·断链**通常只在一个阶段被启用：
**当系统运行得"过于顺畅"时。**

他的原生世界曾被誉为治理范本。
产业高度集中、效率极高、风险被精确量化，失败几乎被消除。
城市之间的差异逐渐缩小，竞争被认为是多余的噪音。

然后，变化停止了。

雷恩并不是在混乱中成长的，
而是在**完美稳定**中看到了停滞的代价。`,
    noticed: `在一次被内部称为"示范级成功"的世界评估中，
雷恩提交了一份极不合群的结论：

> "该系统的失败率接近于零，
> 但其新进入者存活率也接近于零。"

他进一步指出：
当结构固化到无法被挑战时，
效率本身就会转化为**隐性垄断**。

这份报告在当时几乎被忽略。
直到数个周期后，该世界在外部冲击下迅速崩解，
原因并非资源不足，而是**缺乏替代结构**。`,
    joining: `雷恩加入议会时，明确拒绝了常规授权框架。
他要求的并不是更多控制权，而是**破坏权**。

最终，议会通过了一项高度受限的授权条款：
允许其在特定条件下，对高度集中结构进行**强制拆解**，
即便该结构在短期内仍然"表现良好"。

这套机制后来被称为**"断链条款"**。`,
    styleIntro: '雷恩并不关心短期损失。\n\n他坚持三条判断标准：',
    style: [
      '**没有被挑战的优势，最终都会退化**',
      '**结构的健康度，取决于替代路径的存在**',
      '**竞争不是浪费，而是系统的自检机制**',
    ],
    styleOutro: `在棋盘上，他的行动往往被视为破坏性。
高等级地产被拆分，垄断收益被削弱，
短期内整体效率明显下降。

但与此同时，
新的参与者、新的路径与新的博弈空间被重新释放。`,
    relationships: [
      { target: '议会金融家', description: '在资产集中度问题上长期对立' },
      { target: '政治操盘手', description: '在制度设计上存在原则性分歧' },
      { target: '理想主义议员', description: '在"是否需要破坏才能重建"上反复辩论' },
    ],
    themeSummary: '真正的风险，\n不是混乱，\n而是一个再也无法被打破的秩序。',
  },

  'ophelia-nightveil': {
    nameZh: '奥菲利亚·夜幕',
    titleZh: '暗影议员',
    identity: '维度议会 · 隐性事务与非常规决策顾问',
    alignment: '隐秘影响 / 长线布局 / 非公开博弈',
    background: `在维度议会中，有些名字被频繁提及。
而有些名字，几乎从未出现在正式记录里。

**奥菲利亚·夜幕**属于后者。

她的原生世界并不以科技或资本闻名，而以一种特殊的制度而存在——
"**双层决策结构**"。

在公开议会之外，始终存在一个"观察层"。
这个层级并不直接投票，也不签署条约，但它决定了哪些议题值得被讨论，哪些冲突值得被延迟。

奥菲利亚正是在这个结构中成长起来的。`,
    noticed: `在一次多世界冲突中，议会内部出现严重分裂。
所有数据都指向一次不可避免的对抗升级。

而在正式投票之前，对抗双方突然同时修改了立场。

没有人公开承认妥协。
没有任何条款被更改。
只是"氛围"发生了变化。

事后调查中，唯一反复出现的名字是：

> Ophelia Nightveil

但调查记录中没有直接证据。
只有一条注释：

> "该代理人未改变规则，
> 但改变了参与者对规则的预期。"`,
    joining: `奥菲利亚并未被正式任命为常规执行官。
她的身份更接近一种"结构性变量"。

她推动建立了后来被称为"**影幕协议**"的机制：

在重大决策前，引入非公开协商窗口；允许部分影响力被隐藏或延迟揭示；在特定条件下，触发秘密胜利路径。

这一机制饱受争议。
因为它让系统变得更加复杂，也更加难以预测。

但支持者认为：

> "透明并不总等于稳定。"`,
    styleIntro: '奥菲利亚极少正面交锋。\n\n她关注三件事：',
    style: [
      '谁以为自己已经赢了',
      '谁忽略了未被统计的变量',
      '什么时候公开并不等于真实',
    ],
    styleOutro: `在棋盘上，她往往不追求最大收益。
她更倾向于隐藏部分影响力，在关键时刻改变胜负结构。

当结算阶段到来时，她的优势常常在最后一轮才显现。`,
    relationships: [
      { target: '政治操盘手', description: '公开合作，私下互相试探' },
      { target: '信息商人', description: '理念相近，但在"控制与操控"的边界上存在分歧' },
      { target: '秩序执行官', description: '长期处于制度张力之中' },
    ],
    themeSummary: '真正的力量，不在于被看到，\n而在于被假设。',
  },
};

export function getLoreById(id) {
  return CHARACTER_LORE[id] || null;
}
